import React from 'react';
import { Helmet } from 'react-helmet-async';
import NoidaLocation from '../components/NoidaLocation';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://wayug.com/' },
    { '@type': 'ListItem', position: 2, name: 'Noida', item: 'https://wayug.com/noida' },
  ],
};

export default function NoidaPage() {
  return (
    <div className="page-content subpage-content">
      <Helmet>
        <title>Software Development Company in Noida | Cloud, ERP &amp; AI – Wayug</title>
        <meta
          name="description"
          content="Top software development company serving Noida &amp; Greater Noida. Custom ERP, ABDM hospital management software, AI automation, React &amp; Cloud solutions."
        />
        <link rel="canonical" href="https://wayug.com/noida" />
        <meta property="og:title" content="Software Development Company in Noida | Wayug Infotech" />
        <meta
          property="og:description"
          content="Empowering Noida tech startups and enterprises with custom software, ABDM hospital information systems, and cloud infrastructure."
        />
        <meta property="og:url" content="https://wayug.com/noida" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>
      <NoidaLocation />
    </div>
  );
}
